export const Filter = {
  Search: "search" as const,
  InvoiceDate: "invoiceDate" as const,
  HasRules: "hasRules" as const,
  HasUnpaidInvoices: "hasUnpaidInvoices" as const,
  NumberOfInvoices: "numberOfInvoices" as const,
  InvoicedAmount: "invoicedAmount" as const,
}

export const Settings = {
  Id: "id" as const,
  Pg: "pg" as const,
  Street1: "street1" as const,
  Street2: "street2" as const,
  City: "city" as const,
  ZipCode: "zipCode" as const,
  Country: "country" as const,
  CountryName: "countryName" as const,
  PaymentTerms: "paymentTerms" as const,
  SupplierName: "supplierName" as const,
  SupplierOrgNr: "supplierOrgNr" as const,
  Address: "address" as const,
  Rules: "rules" as const,
  Amounts_bookingAccountName: "amounts_bookingAccountName" as const,
  RulePeriod_dates_dimensions: "rulePeriod_dates_dimensions" as const,
}

export const Rule = {
  Id: "id" as const,
  Active: "active" as const,
  BookingAccountId: "bookingAccountId" as const,
  BookingAccountName: "bookingAccountName" as const,
  RulePeriod: "rulePeriod" as const,
  RulePeriodName: "rulePeriodName" as const,
  AmountHighest: "amountHighest" as const,
  AmountLowest: "amountLowest" as const,
  DateFrom: "dateFrom" as const,
  DateTo: "dateTo" as const,
  Dimensions: "dimensions" as const,
}

